import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserService, supabase } from '../services/supabase';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const finalizeCallback = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      const errorDescription =
        queryParams.get('error_description') ||
        hashParams.get('error_description') ||
        queryParams.get('error') ||
        hashParams.get('error');

      if (errorDescription) {
        if (isMounted) {
          navigate(
            `/verify-email?status=error&message=${encodeURIComponent(errorDescription)}`,
            { replace: true }
          );
        }
        return;
      }

      // Manual-first-login flow: even if Supabase created a transient session,
      // clear it and send the user to the login screen.
      const userService = new UserService();
      const { data: { session } } = await supabase.auth.getSession();
      const verifiedEmail = session?.user?.email;
      if (session) {
        await userService.signOut();
      }

      if (isMounted) {
        const params = new URLSearchParams();
        params.set('action', 'login');
        params.set('emailVerified', '1');
        if (verifiedEmail) {
          params.set('email', verifiedEmail);
        }
        navigate(`/auth?${params.toString()}`, { replace: true });
      }
    };

    void finalizeCallback();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-xl font-semibold">Finalizing verification...</h1>
      </div>
    </div>
  );
}
